import React, { useEffect, useState } from 'react'
import moment from 'moment'
import API from '../../../../services/API'
import BigModal from '../../../../components/Modals/BigModal'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import PresetsTextField from '../../../../components/Forms/PresetsTextField'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Alert, Button, LinearProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Age from '../../../../components/Age'

const AccessPopup = ({ epcrID, paperPCRID, setAccessLogged }) => {
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [accessReason, setAccessReason] = useState('')
  const [record, setBasicRecordDetails] = useState(null)
  const [postError, setPostError] = useState(false)
  const [uploading, setUploading] = useState(false)

  const navigate = useNavigate()
  useEffect(() => {
    API.get(
      epcrID
        ? '/epcrreport/basics/' + epcrID
        : '/paper-pcr/basics/' + paperPCRID,
    )
      .then((res) => {
        if (res.status === 200) {
          setBasicRecordDetails(res.data)
        } else if (res.status === 403) {
          navigate('/patient-report-forms')
        } else {
          setFetchError(true)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [epcrID, paperPCRID])

  const handleSubmit = (e) => {
    e.preventDefault()
    setUploading(true)
    setPostError(false)
    API.post('/epcrreport/accesslog', {
      epcrID,
      paperPCRID,
      reason: accessReason,
    })
      .then((res) => {
        if (res.status === 200) {
          setAccessLogged(res.data)
        } else {
          setPostError(true)
        }
      })
      .catch((e) => setPostError(true))
      .finally(() => setUploading(false))
  }

  return (
    <BigModal open={true} onClose={() => {}}>
      <EPCRCard>
        {loading ? (
          <LinearProgress />
        ) : (
          <Stack component="form" onSubmit={handleSubmit} gap={2}>
            <Stack direction="row" gap={2} justifyContent="space-between">
              <Typography>{`${
                record?.demographics?.lastName
                  ? record?.demographics?.lastName + ','
                  : ''
              } ${
                record?.demographics?.firstName
                  ? record?.demographics?.firstName?.[0]
                  : ''
              } ${
                record?.demographics?.dob
                  ? '(' + Age(record.demographics.dob, record?.createdAt) + ')'
                  : ''
              }`}</Typography>
              <Typography>
                {record &&
                  moment(
                    record?.incident?.incidentDate ??
                      record?.incidentDate ??
                      record?.createdAt,
                  ).format('DD/MM/YYYY HH:mm')}
              </Typography>
            </Stack>
            <PresetsTextField
              value={accessReason}
              required
              setValue={setAccessReason}
              label="Reason for Accessing Record"
              presets={[
                'Clinical Advice Line',
                'Audit',
                'Investigating an incident',
                'Reviewing Health & Safety Incident',
                'Preparing a patient report for transfer to another organisation',
                'Reviewing clinical care provided',
                'Compliance audit or quality assurance',
                'Request from external healthcare provider',
                'Preparing for legal inquiry or investigation',
                'Managerial oversight or review',
                'Responding to a patient or family request',
                'Following up on a previous treatment',
              ]}
            />
            {(postError || fetchError) && (
              <Alert severity="error">
                {postError
                  ? 'Unable to record your access reason. Please try again.'
                  : 'Unable to fetch record details. Please try again later.'}
              </Alert>
            )}
            <Button
              variant="outlined"
              type="button"
              color="error"
              onClick={() => navigate('/patient-report-forms')}
            >
              Go Back
            </Button>
            <Button
              variant="contained"
              color="success"
              type="submit"
              disabled={loading || uploading}
            >
              Submit
            </Button>
          </Stack>
        )}
      </EPCRCard>
    </BigModal>
  )
}

export default AccessPopup
